import React, { useEffect, useRef } from 'react';

const VideoEmbed = ({ videoUrl }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.focus();
    }
  }, []);

  return (
    <div
      style={{ width: '100%', paddingBottom: '56.25%', position: 'relative' }}
    >
      <iframe
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '80%',
        }}
        src={videoUrl}
        title='YouTube video player'
        frameBorder='0'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;'
        // allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        allowFullScreen
        autoPlay
      ></iframe>
      {/* <iframe
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
      }}
        _ngcontent-fts-c36=""
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen=""
        class="video"
        src="https://youtube.com/embed/H9bfqozjoqs"
      ></iframe> */}
    </div>
  );
};

export default VideoEmbed;
